import React from "react";
import { RotateDeviceGif } from "../images";

const RotateDevice = () => {
  return (
    <div className="fog_rotate_device_content">
      <img src={RotateDeviceGif} />
      <h3>Please rotate your device!</h3>
    </div>
  );
};

export default RotateDevice;
